/* eslint-disable max-classes-per-file */
import EntitiesList from 'aurelio/src/abstracts/entitiesList';

export class ProductFeedsJobsList extends EntitiesList {
  constructor(appAPI, accountId, jobFormatter) {
    super();

    this._appAPI = appAPI;
    this._accountId = accountId;
    this._jobFormatter = jobFormatter;
    this._setPaginationAsList();
  }
  cancelJob(jobId) {
    this.changeJobStatus(jobId, 'canceled');
  }
  changeJobStatus(jobId, status) {
    this._entities = this._entities.map((entity) => (
      entity.id === jobId ?
        Object.assign({}, entity, { status }) :
        entity
    ));
  }
  loadJobs() {
    return this._loadFirstPage();
  }
  moveToTheNextPage() {
    return this._moveTheListToTheNextPage();
  }
  moveToThePreviousPage() {
    return this._moveTheListToThePreviousPage();
  }
  _formatResponse(response) {
    return {
      entities: response.job_executions.map((job) => this._jobFormatter(job)),
      total: response.pagination.total,
    };
  }
  _getProducts() {
    return this._appAPI.getProductFeedsJobs(
      this._accountId,
      this.currentPage,
      this.itemsPerPage,
      this.sortBy,
      this.sortAsc ? 'asc' : 'desc',
    );
  }
  _makeFirstPageRequest() {
    return this._getProducts();
  }
  _makeNextPageRequest() {
    return this._getProducts();
  }
}

export class ProductFeedsJobsListManager {
  constructor(appAPI) {
    'inject';

    this._appAPI = appAPI;
  }
  newList(accountId, jobFormatter) {
    return new ProductFeedsJobsList(this._appAPI, accountId, jobFormatter);
  }
}
